import { render, staticRenderFns } from "./WhatsappHistoryExport.vue?vue&type=template&id=dea3d946"
import script from "./WhatsappHistoryExport.vue?vue&type=script&lang=js"
export * from "./WhatsappHistoryExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports